import { Icon } from '@/components/icons/svg-icons'
import { appDownloadStyles } from './app-download.style'
import Image from 'next/image'
import { useEffect, useState } from 'react';
import { useAthenaSiteConfig } from '@/hooks/query/athena/use-athena-site-config';
import { appDownloadService } from '@/services/jupiter/app-download-service';
import { useTranslations } from 'next-intl';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';

const LOCAL_STORAGE_KEY = 'appDownloadLastShownDate';

export const AppDownload = () => {
	const t = useTranslations('General');
	const { data: athenaSiteConfig } = useAthenaSiteConfig();
	const { SiteConfigsData } = useGetSiteConfigs();
	const siteId = SiteConfigsData?.GetMessageID?.substring(0, 5) || '';

	const [showAppDownload, setShowAppDownload] = useState(false);

	useEffect(() => {
		const hasShownToday = () => {
			const lastShownDate = localStorage.getItem(LOCAL_STORAGE_KEY);
			if (!lastShownDate) return false;

			const today = new Date().toISOString().slice(0, 10);
			return lastShownDate === today;
		};

		if (athenaSiteConfig?.DownloadAPPUrl && !hasShownToday()) {
			setShowAppDownload(true);
			// Store today's date in localStorage
			const today = new Date().toISOString().slice(0, 10);
			localStorage.setItem(LOCAL_STORAGE_KEY, today);
		}
	}, [athenaSiteConfig?.DownloadAPPUrl]);

	return showAppDownload && athenaSiteConfig?.DownloadAPPUrl ? (
		<div className={appDownloadStyles.banner}>
			<div className={appDownloadStyles.bannerContent}>
				<div
					className={appDownloadStyles.closeIcon}
					onClick={() => setShowAppDownload(false)}
				>
					<Icon name="close-big" />
				</div>
				<Image
					src={`/images/jupiter/${siteId}/logo_app.png`}
					alt="App logo"
					className={appDownloadStyles.appLogo}
					width={'45'}
					height={'45'}
				/>
				<div className={appDownloadStyles.appInfo}>
					<div className={appDownloadStyles.appLabel}>
						New
					</div>
					<div>{SiteConfigsData?.SiteName} {t('lbl_APPdownload_NativeApp')}</div>
				</div>
				<button
					className={appDownloadStyles.downloadButton}
					onClick={() => appDownloadService.openAppDownload(athenaSiteConfig.DownloadAPPUrl)}
				>
					{t('lbl_download')}
				</button>
			</div>
		</div>
	) : null
}
